module.exports = __webpack_public_path__ + "img/TL.a7e8ee40.png";